/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable no-dupe-keys */
import PageFooter from "../../shared/app-shell/PageFooter";
import { selectedVesselDetailsAtom, themeAtom } from "../../shared/atoms";
import LoadingWrapper from "../../shared/components/LoadingWrapper";
import ReadOnlyForm from "../../shared/components/ReadOnlyForm";
import { fetchDataWithParams } from "../../shared/services/service";
import { useAtomValue, useSetAtom } from "jotai";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { twMerge } from "tailwind-merge";

const GeneralInformationTab: React.FC = () => {
  const theme = useAtomValue(themeAtom);

  const { imoNumber, vesselCode } = useParams();
  const setSelectedVesselDetails = useSetAtom(selectedVesselDetailsAtom);
  useEffect(() => {
    //("Vessel Info");
    if (imoNumber && vesselCode) {
      fetchData();
    }
  }, [imoNumber, vesselCode]);
  const [isLoading, setIsLoading] = useState(false);
  const [vesselInfoDataTab, setVesselInfoDataTab] = useState<any[]>([]);
  const fetchData = async () => {
    try {
      const requestData = {
        imo_no: imoNumber,
        vessel_code: vesselCode,
      };
      const filteredRequestData = Object.fromEntries(
        Object.entries(requestData).filter(([_, value]) => value !== undefined && value !== null),
      ) as Record<string, string>;
      const queryParams = new URLSearchParams(filteredRequestData).toString();
      setIsLoading(true);
      const result = await fetchDataWithParams(`VesselDetails?${queryParams}`);
      setVesselInfoDataTab(result.data);
      setSelectedVesselDetails(result.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };
  const formData = {
    "Vessel code": vesselInfoDataTab[0]?.VESSEL_CODE ?? "",
    "IMO Number": vesselInfoDataTab[0]?.IMO_NUMBER ?? "",
    "Vessel type": vesselInfoDataTab[0]?.VESSEL_TYPE ?? "",
    "Class society": vesselInfoDataTab[0]?.SOCIETY_CODE ?? "",
    "Year built": vesselInfoDataTab[0]?.YEAR_BUILT ?? "",
    "Vessel email": vesselInfoDataTab[0]?.VESSEL_EMAIL ?? "",
    "Grab Types (supramax only)": vesselInfoDataTab[0]?.GRAB_TYPES_SUPRAMAX_ONLY ?? "",
    "Box shaped Holds (Handy only)": vesselInfoDataTab[0]?.HOLD_BOX_SHAPED_HANDY_ONLY ?? "",
    "Scrubber type": vesselInfoDataTab[0]?.SCRUBBER_TYPE ?? "",
    "Neo Panama Fitted (Panamax only)": "",
    CO2Fitted: vesselInfoDataTab[0]?.CO2_FITTED?.toString() ?? "",
    A60Fitted: vesselInfoDataTab[0]?.A60_FITTED?.toString() ?? "",
  };

  return (
    <LoadingWrapper isLoading={isLoading} loadingIndicatorClassName="text-green" loadingIndicatorSize="lg">
      <div className="flex flex-col">
        <div className={twMerge("mb-4 rounded-lg p-6 shadow-md", theme.home.tailwind.panelBackground)}>
          <ReadOnlyForm data={formData} />
        </div>
        <PageFooter />
      </div>
    </LoadingWrapper>
  );
};

export default GeneralInformationTab;
